import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { gettext } from "../../../../i18n";
import { Button } from "react-bootstrap";

function UserManualButton() {
  return (
    <Button
      className="btn btn-light"
      href="https://mittausguru.fi/wp-content/uploads/2025/02/mittausgurun-pilvipalvelun-kayttoohjeet-asiakkaille.pdf"
      target="_blank"
    >
      <span className="button-text">{gettext("User Manual")}</span>
      <FontAwesomeIcon icon="book" />
    </Button>
  );
}

export default UserManualButton;
